import './UserInfo.scss';

export { default } from './UserInfo';
